import { defaultDesignValues } from '@systemeio/digital-store-shared'
import { StoreCreateInterface, StoreErrorsInterface } from 'modules/stores/types/stores-interface'

export const storeDefaultErrors: StoreErrorsInterface = {
  name: '',
  path: '',
  domainId: '',
  locale: '',
  active: '',
  currency: '',
  paymentMethods: '',
  design: '',
  displayAffiliateLink: '',
  author: '',
  description: '',
  image: '',
  keywords: '',
  title: '',
  trackingCode: '',
  common: '',
}

export const storeDefaultCreateValues: StoreCreateInterface = {
  name: '',
  path: '',
  domainId: undefined,
  design: defaultDesignValues.default,
  locale: undefined,
  currency: undefined,
}
